import { helpers } from 'vuelidate/lib/validators';

const username = helpers.regex('username', /^[a-z0-9_-]{3,20}$/);

export default {
  username,
};
